export const mainUrl = 'https://outline.yeminhtwe.com/api/';